import React from 'react';
import { useIntersectionObserver } from '../hooks/useIntersectionObserver';

const Testimonials = () => {
  const ref = useIntersectionObserver();

  const testimonials = [
    {
      name: 'Aisha Khan',
      text: '"Delivered on time and exceeded expectations. Great communication."',
      image: 'images/testimonial1.jpeg' // keep your image as is
    },
    {
      name: 'Bilal Ahmed',
      text: '"Impressive knowledge of AI integration — boosted our support automation."',
      image: 'images/testimonial.avif' // keep your image as is
    }
  ];

  return (
    <section id="testimonials" className="section">
      <div ref={ref} className="container container-lg" data-animate>
        <h2>Testimonials</h2>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(240px,1fr))', gap: '14px' }}>
          {testimonials.map(testimonial => (
            <div key={testimonial.name} className="card-glass">
              <div className="testi" style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                <img
                  src={testimonial.image}
                  alt={`testimonial from ${testimonial.name}`}
                  style={{ width: '60px', height: '60px', borderRadius: '50%', objectFit: 'cover' }}
                />
                <div>
                  <strong style={{ color: 'var(--text)' }}>{testimonial.name}</strong>
                  <p style={{ margin: '4px 0 0', color: 'var(--muted)', fontSize: '14px' }}>{testimonial.text}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Testimonials;
